import styled from 'styled-components';

export const StyledCard = styled.div``;
export const StyledHeader = styled.div`
  background-color: ${(props) => props.theme.color.bodyTextColor};
  color: ${(props) => props.theme.color.white};
  padding: 2rem;
  border-top-left-radius: ${(props) => props.theme.radius.md};
  border-top-right-radius: ${(props) => props.theme.radius.md};
`;

export const StyledBody = styled.div`
  border: 1px solid ${(props) => props.theme.color.borderColor};
  padding: 1rem 2rem;

  border-bottom-left-radius: ${(props) => props.theme.radius.md};
  border-bottom-right-radius: ${(props) => props.theme.radius.md};

  @media (max-width: 768px) {
    padding: 1.5rem;
  }
`;
